import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Select from "react-select";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    InputGroup,
    Nav,
    NavItem,
    TabContent,
    TabPane,
    CardText,

} from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import AccountsTab from "./AccountsTab";
import InvoiceTab from "./InvoiceTab";
import PaymentsTab from "./PaymentsTab";
import ViewInoice from "./ViewInoice";
import SearchAccount from "./SearchAccount";
import PaperRA from "./PaperRA";
import MedicalInsurers from "./MedicalInsurers";
import SuspenseAccount from "./SuspenseAccount";
import Recollection from './Recollection';
import InvoiceNew from '../Invoice/Invoice_new';

import classnames from "classnames";


const defaultValue = {

}

const Accounts = () => {
    const [customActiveTab, setcustomActiveTab] = useState("1"); // main
    const [verticalActiveTab, setverticalActiveTab] = useState("1");
    const [collectionsActiveTab, setCollectionsActiveTab] = useState("5"); // nested

    const toggleCustom = tab => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };
    const toggleVertical = tab => {
        if (verticalActiveTab !== tab) {
            setverticalActiveTab(tab);
        }
    };

    const toggleCollections = tab => {
    if (collectionsActiveTab !== tab) {
        setCollectionsActiveTab(tab);
    }
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Card>
                            <CardBody>
                                <CardTitle className="mb-4"></CardTitle>
                                <Form>
                                     {/* Main Tabs */}
                                     
                                    <Nav tabs className="nav-tabs-custom nav-justified">
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames("pb-2", {
                                                    active: customActiveTab === "1",
                                                    "border-bottom border-primary text-primary fw-bold": customActiveTab === "1",
                                                })}
                                                onClick={() => {
                                                    toggleCustom("1");
                                                }}
                                            >
                                                <span className="d-block d-sm-none">
                                                    <i className="fas fa-home"></i>
                                                </span>
                                                <span className="d-none d-sm-block">Inbox</span>
                                            </NavLink>
                                        </NavItem>

                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames("pb-2", {
                                                    active: customActiveTab === "2",
                                                    "border-bottom border-primary text-primary fw-bold": customActiveTab === "2",
                                                })}
                                                onClick={() => {
                                                    toggleCustom("2");
                                                }}
                                            >
                                                <span className="d-block d-sm-none">
                                                    <i className="far fa-user"></i>
                                                </span>
                                                <span className="d-none d-sm-block">Accounts</span>
                                            </NavLink>
                                        </NavItem>

                                    </Nav>


                                    <TabContent
                                        activeTab={customActiveTab}
                                        className="p-3 text-muted"
                                    >

                                         {/* ================= INBOX ================= */}

                                        <TabPane tabId="1">
                                            <Row>
                                                {/* Left side: Vertical Tabs */}
                                                <Col sm="2">
                                                    <Nav pills className="flex-column">
                                                        <NavItem>
                                                            <NavLink
                                                                style={{ cursor: "pointer" }}
                                                                className={classnames("mb-2", {
                                                                    "border-start border-primary text-primary fw-bold": verticalActiveTab === "1",
                                                                })}
                                                                onClick={() => toggleVertical("1")}
                                                            >
                                                                Invoice
                                                            </NavLink>
                                                        </NavItem>
                                                        <br />
                                                        <NavItem>
                                                            <NavLink
                                                                style={{ cursor: "pointer" }}
                                                                className={classnames("mb-2", {
                                                                    "border-start border-primary text-primary fw-bold": verticalActiveTab === "2",
                                                                })}
                                                                onClick={() => toggleVertical("2")}
                                                            >
                                                                Collections
                                                            </NavLink>
                                                        </NavItem>

                                                        <br />
                                                        <NavItem>
                                                            <NavLink
                                                                style={{ cursor: "pointer" }}
                                                                className={classnames("mb-2", {
                                                                    "border-start border-primary text-primary fw-bold": verticalActiveTab === "3",
                                                                })}
                                                                onClick={() => toggleVertical("3")}
                                                            >
                                                                Recollection
                                                            </NavLink>
                                                        </NavItem>


                                                    </Nav>
                                                </Col>

                                                {/* Right side: Tab Content */}
                                                <Col sm="10">
                                                    <TabContent
                                                        activeTab={verticalActiveTab}
                                                        className="text-muted"
                                                    >
                                                        <TabPane tabId="1">
                                                            <Col md={6}>
                                                                <div className="mb-3">
                                                                    <Label htmlFor="formrow-country-Input">Name</Label>
                                                                    <Input type="text" className="form-control" name="name" placeholder="Enter Name" />
                                                                </div>
                                                            </Col>
                                                        </TabPane>


                                                        {/* ========== Collections Tab with Nested Tabs ========== */}
                                                       <TabPane tabId="2">
                                                            <Col md={12}>
                                                                {/* Nested Tabs */}
                                                                <Nav tabs className="nav-tabs-custom nav-justified">
                                                                    <NavItem>
                                                                        <NavLink
                                                                            style={{ cursor: "pointer" }}
                                                                            className={classnames("pb-2", {
                                                                                active: collectionsActiveTab === "5",
                                                                                "border-bottom border-primary text-primary fw-bold": collectionsActiveTab === "5",
                                                                            })}
                                                                            onClick={() => toggleCollections("5")}
                                                                        >
                                                                            Accounts
                                                                        </NavLink>
                                                                    </NavItem>

                                                                    <NavItem>
                                                                        <NavLink
                                                                            style={{ cursor: "pointer" }}
                                                                            className={classnames("pb-2", {
                                                                                active: collectionsActiveTab === "6",
                                                                                "border-bottom border-primary text-primary fw-bold": collectionsActiveTab === "6",
                                                                            })}
                                                                            onClick={() => toggleCollections("6")}
                                                                        >
                                                                            Invoices
                                                                        </NavLink>
                                                                    </NavItem>

                                                                    <NavItem>
                                                                        <NavLink
                                                                            style={{ cursor: "pointer" }}
                                                                            className={classnames("pb-2", {
                                                                                active: collectionsActiveTab === "9",
                                                                                "border-bottom border-primary text-primary fw-bold": collectionsActiveTab === "9",
                                                                            })}
                                                                            onClick={() => toggleCollections("9")}
                                                                        >
                                                                            Payments
                                                                        </NavLink>
                                                                    </NavItem>
                                                                </Nav>

                                                                {/* Nested Tab Content */}
                                                                <TabContent activeTab={collectionsActiveTab} className="p-3 text-muted">
                                                                    <TabPane tabId="5">
                                                                        <Row>
                                                                            <Col sm="12">
                                                                                <AccountsTab />
                                                                            </Col>
                                                                        </Row>
                                                                    </TabPane>

                                                                    <TabPane tabId="6">
                                                                        <Row>
                                                                            <Col sm="12">
                                                                            <InvoiceTab />
                                                                            </Col>
                                                                        </Row>
                                                                    </TabPane>

                                                                    <TabPane tabId="9">
                                                                        <Row>
                                                                            <Col sm="12">
                                                                            <PaymentsTab />
                                                                            </Col>
                                                                        </Row>
                                                                    </TabPane>
                                                                </TabContent>
                                                            </Col>
                                                        </TabPane>

                                                        <TabPane tabId="3">
                                                           <Row>
                                                                            <Col sm="12">
                                                                            <Recollection />
                                                                            </Col>
                                                                        </Row>
                                                        </TabPane>



                                                        
                                                    </TabContent>
                                                </Col>
                                            </Row>

                                        </TabPane>

                                        <TabPane tabId="2">
                                            <Row>
                                                {/* Left side: Vertical Tabs */}
                                                <Col sm="2">
                                                    <Nav pills className="flex-column">
                                                        
                                                        <NavItem>
                                                            <NavLink
                                                                style={{ cursor: "pointer" }}
                                                                className={classnames("mb-2", {
                                                                    "border-start border-primary text-primary fw-bold": verticalActiveTab === "1",
                                                                })}
                                                                onClick={() => toggleVertical("1")}
                                                            >
                                                                Search Accounts
                                                            </NavLink>
                                                        </NavItem>

                                                         <br />

                                                         <NavItem>
                                                            <NavLink
                                                                style={{ cursor: "pointer" }}
                                                                className={classnames("mb-2", {
                                                                    "border-start border-primary text-primary fw-bold": verticalActiveTab === "2",
                                                                })}
                                                                onClick={() => toggleVertical("2")}
                                                            >
                                                                View Invoices
                                                            </NavLink>
                                                        </NavItem>

                                                        <br />


                                                        <NavItem>
                                                            <NavLink
                                                                style={{ cursor: "pointer" }}
                                                                className={classnames("mb-2", {
                                                                    "border-start border-primary text-primary fw-bold": verticalActiveTab === "3",
                                                                })}
                                                                onClick={() => toggleVertical("3")}
                                                            >
                                                                Capture Invoice
                                                            </NavLink>
                                                        </NavItem>

                                                         <br />

                                                         <NavItem>
                                                            <NavLink
                                                                style={{ cursor: "pointer" }}
                                                                className={classnames("mb-2", {
                                                                    "border-start border-primary text-primary fw-bold": verticalActiveTab === "4",
                                                                })}
                                                                onClick={() => toggleVertical("4")}
                                                            >
                                                                Capture Paper RA
                                                            </NavLink>
                                                        </NavItem>

                                                         <br />

                                                         <NavItem>
                                                            <NavLink
                                                                style={{ cursor: "pointer" }}
                                                                className={classnames("mb-2", {
                                                                    "border-start border-primary text-primary fw-bold": verticalActiveTab === "5",
                                                                })}
                                                                onClick={() => toggleVertical("5")}
                                                            >
                                                                Medical Insurers
                                                            </NavLink>
                                                        </NavItem>

                                                         <br />

                                                         <NavItem>
                                                            <NavLink
                                                                style={{ cursor: "pointer" }}
                                                                className={classnames("mb-2", {
                                                                    "border-start border-primary text-primary fw-bold": verticalActiveTab === "6",
                                                                })}
                                                                onClick={() => toggleVertical("6")}
                                                            >
                                                                Suspense Account
                                                            </NavLink>
                                                        </NavItem>

                                                        
                                                    </Nav>
                                                </Col>

                                                {/* Right side: Tab Content */}
                                                <Col sm="10">
                                                    <TabContent
                                                        activeTab={verticalActiveTab}
                                                        className="text-muted"
                                                    >
                                                        <TabPane tabId="1">
                                                             <Row>
                                                                            <Col sm="12">
                                                                            <SearchAccount />
                                                                            </Col>
                                                                        </Row>
                                                        </TabPane>

                                                        <TabPane tabId="2">
                                                           <Row>
                                                                            <Col sm="12">
                                                                            <ViewInoice />
                                                                            </Col>
                                                                        </Row>
                                                        </TabPane>

                                                        <TabPane tabId="3">
                                                           <Row>
                                                                            <Col sm="12">
                                                                            <InvoiceNew />
                                                                            
                                                                            </Col>
                                                                        </Row>
                                                        </TabPane>

                                                        <TabPane tabId="4">
                                                           <Row>
                                                                            <Col sm="12">
                                                                            <PaperRA />
                                                                            
                                                                            </Col>
                                                                        </Row>
                                                        </TabPane>

                                                         <TabPane tabId="5">
                                                           <Row>
                                                                            <Col sm="12">
                                                                            <MedicalInsurers />
                                                                            
                                                                            </Col>
                                                                        </Row>
                                                        </TabPane>

                                                          <TabPane tabId="6">
                                                           <Row>
                                                                            <Col sm="12">
                                                                            <SuspenseAccount />
                                                                            
                                                                            </Col>
                                                                        </Row>
                                                        </TabPane>
                                                    </TabContent>
                                                </Col>
                                            </Row>
                                        </TabPane>

                                    </TabContent>
                                    <div className="text-end">
                                        <button
                                            className="btn btn-success w-md mx-2"
                                        // onClick={(e) => addCountryDetails(e)}
                                        >
                                            Save
                                        </button>
                                    </div>

                                </Form>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Accounts
